import { render, staticRenderFns } from "./AboutEyedock.vue?vue&type=template&id=7a0b019b&scoped=true&"
import script from "./AboutEyedock.vue?vue&type=script&lang=js&"
export * from "./AboutEyedock.vue?vue&type=script&lang=js&"
import style0 from "./AboutEyedock.vue?vue&type=style&index=0&id=7a0b019b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b019b",
  null
  
)

export default component.exports